export default __webpack_public_path__ + "static/media/20s_line_cleared.77b72355.mp3";